import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {DESCRIPTION_CLASS, TITLE_CLASS} from "components/Survey/classes";
import clsx from "clsx";

export const PainsAndGainsDescription_Paragraph2 = ({businessName}: SurveySectionsRenderingModel) =>
    <p className={clsx("mb-4", DESCRIPTION_CLASS)}>
      Let’s take a look at how {businessName} fits in.
      Next, you will see some universal pains, fears, and irritations as well as typical hopes,
      aspirations, and goals.
      Try to think at a very high level about what people are feeling
      (or trying to avoid feeling) when they come to you.
    </p>;

export const HopesAspirationsGoalsTitle = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>What are their hopes, aspirations, and goals that {businessName} can help with?</span>;
